"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParticipantSource = void 0;
var ParticipantSource;
(function (ParticipantSource) {
    ParticipantSource["Student"] = "Student";
    ParticipantSource["Aluminati"] = "Aluminati";
})(ParticipantSource = exports.ParticipantSource || (exports.ParticipantSource = {}));
//# sourceMappingURL=participant-sources.js.map